/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { useCallback, useEffect, useRef } from 'react';

import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import videojs from 'video.js';
import 'videojs-contrib-quality-levels';
import 'videojs-http-source-selector';
import 'videojs-youtube';
import { BASEURL } from '../../config';
import { addSituationAnswer, setAnswered } from '../../redux/slices/gplx.situation.slice';
// ----------------------------------------------------------------------

export default function VideoPlayerPreview({ video, prevItem, nextItem }) {
  const type = "VIDEO";

  return (
    <>
      {type === 'VIDEO' && <PreviewVideo video={video} prevItem={prevItem} nextItem={nextItem} />}
    </>
  );
}

// ----------------------------------------------------------------------

function PreviewVideo({ video, prevItem, nextItem }) {
  const playerRef = useRef(null);
  const dispatch = useDispatch();
  const router = useRouter();

  const { isAnswered, hint } = useSelector((state) => state.situation);

  useEffect(() => {
    if (!playerRef.current) {
      const options = {
        playbackRates: [0.5, 1, 1.5, 2],
        fluid: true,
        fill: true,
        responsive: true,
        controls: true,
        preload: 'auto',
        autoplay: true,
        aspectRatio: "16:9",
        controlBar: {
          remainingTimeDisplay: false,
          currentTimeDisplay: true,
          pictureInPictureToggle: false,
          playbackRateMenuButton: false,
          timeDivider: true,
          durationDisplay: true
        },
        userActions: {
          hotkeys: function (event) {
            // `this` is the player in this context
            event.preventDefault();
            if (event.target.type === 'button') {
              event.target.blur();
            }

            if (event.which === 32) {
              spaceFnc(event);
              return false;
            }

            return true;
          }
        },
        inactivityTimeout: 0,
        plugins: {
          httpSourceSelector:
          {
            default: 'auto'
          }
        },
        html5: {
          vhs: {
            overrideNative: true,
          },
          nativeAudioTracks: false,
          nativeVideoTracks: false
        },
      };

      const player = playerRef.current = videojs("video_1", options);
      videojs.log.level('off');
      player.playsinline(true);
    }
  }, []);

  useEffect(() => {
    const player = playerRef.current;
    // player.on('timeupdate', function () {
    //   console.log(this.currentTime());
    // });

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  useEffect(() => {
    const player = playerRef.current;
    if (!player.ended())
      if (hint)
        player.pause();
      else
        player.play();
  }, [hint]);

  useEffect(() => {
    const player = playerRef.current;

    if (video) {
      const { id } = video;

      player.poster(`${BASEURL}/stream/video/${id}/thumbnail/thumb.jpg`);
      player.src({
        src: `${BASEURL}/stream/video/${id}/index.m3u8`,
        type: 'application/x-mpegURL',
      });

      drawNavigateBar(player);
    }
    return () => {
      dispatch(setAnswered(false));
      try {
        player?.controlBar?.removeChild('Component');
      } catch { console.log(); }
    };
  }, [video]);

  const spaceFnc = useCallback((event) => {
    event.preventDefault();

    if (event.target.type === 'button') {
      event.target.blur();
    }

    if (event.which === 32) {
      dispatch(setAnswered(true));
    } else if (event.which === 37 && prevItem) {
      router.push({ pathname: `/thi-tinh-huong/${prevItem?.slug}` }, undefined, { scroll: false });
    } else if (event.which === 39 && nextItem) {
      router.push({ pathname: `/thi-tinh-huong/${nextItem?.slug}` }, undefined, { scroll: false });
    }
  }, [video]);

  useEffect(() => {
    if (!isAnswered) {
      document.addEventListener("keydown", spaceFnc, false);
      document.addEventListener("keypress", spaceFnc, false);
    }
    return () => {
      document.removeEventListener("keydown", spaceFnc, false);
      document.removeEventListener("keypress", spaceFnc, false);
    };
  }, [spaceFnc, isAnswered]);

  useEffect(() => {
    const { id, start, end, orderNo } = video;

    if (isAnswered) {
      const player = playerRef.current;
      const currentTime = player.currentTime();

      const duration = player.duration();

      const diff = (end - start) / 5;

      let score = 0;
      if (currentTime >= start && currentTime < start + diff) {
        dispatch(addSituationAnswer({ id, orderNo, seletedTime: currentTime, score: 5 }));
        score = 5;
      } else if (currentTime >= start + diff && currentTime < start + diff * 2) {
        dispatch(addSituationAnswer({ id, orderNo, seletedTime: currentTime, score: 4 }));
        score = 4;
      } else if (currentTime >= start + diff * 2 && currentTime < start + diff * 3) {
        dispatch(addSituationAnswer({ id, orderNo, seletedTime: currentTime, score: 3 }));
        score = 3;
      } else if (currentTime >= start + diff * 3 && currentTime < start + diff * 4) {
        dispatch(addSituationAnswer({ id, orderNo, seletedTime: currentTime, score: 2 }));
        score = 2;
      } else if (currentTime >= start + diff * 4 && currentTime <= end) {
        dispatch(addSituationAnswer({ id, orderNo, seletedTime: currentTime, score: 1 }));
        score = 1;
      } else
        dispatch(addSituationAnswer({ id, orderNo, seletedTime: currentTime, score: 0 }));

      drawResultBar(player, currentTime, duration, diff, start, end, score);
    } else {
      const player = playerRef.current;
      player.controlBar.removeChild('Button');
      player.currentTime(0);
      player.play();
      window.player = player;
    }
  }, [isAnswered]);

  const drawResultBar = (player, currentTime, duration, diff, start, end, score) => {
    const marginLeftSelect = currentTime / duration * 100;
    const timeWidth = diff / duration * 100;

    var myButton = player.controlBar.addChild('Button', {
      className: 'result-bar'
    }, 0);

    // Create our button's DOM Component
    var resultDiv = myButton.el();
    resultDiv.innerHTML = `<div class="result-div"><img style="margin-left:${marginLeftSelect}%;height:35px;" src="/icons/flag.png"/>` +
      `<span class="result-time">${score}</span>`;

    resultDiv.innerHTML += `<span class="result-answer" style="right:${(duration - start) / duration * 100}%;">${start}</span>`;

    for (let i = 0; i < 5; i++) {
      let color = 'red';
      if (i === 0) color = '#008e2c';
      else if (i === 1) color = '#39e500';
      else if (i === 2) color = '#c2e500';
      else if (i === 3) color = '#e56a00';
      else if (i === 4) color = '#e50000';

      const marginLeftStart = (start + diff * i) / duration * 100;

      resultDiv.innerHTML += `<span class="result-answer" style="left:${marginLeftStart}%;width:${timeWidth}%;background-color:${color}"></span>`;
    }
    resultDiv.innerHTML += `<span class="result-answer" style="left:${end / duration * 100}%;">${end}</span>`;
    resultDiv.innerHTML += `</div>`;
  };

  const drawNavigateBar = (player) => {
    let controlBar = player.controlBar?.addChild('Component', {
      className: 'my-navigation'
    }, 0);

    // Create our button's DOM Component
    var resultDiv = controlBar.el();
    resultDiv.innerHTML = `<div class="my-navigation-div">`
      + `<button class="my-button space" onclick="onSpace()">[SPACE]</button>`
      + `<button class="my-button reset" onclick="onReset()">RESET</button>`
      + `<button class="my-button" onclick="onBack()"><< Trước</button>`
      + `<button class="my-button" onclick="onNext()">Sau >></button>`
      + '</div>';
    window.onNext = () => {
      if (nextItem)
        router.push({ pathname: `/thi-tinh-huong/${nextItem?.slug}` }, undefined, { scroll: false });
    };

    window.onBack = () => {
      if (prevItem)
        router.push({ pathname: `/thi-tinh-huong/${prevItem?.slug}` }, undefined, { scroll: false });
    };

    window.onSpace = () => {
      dispatch(setAnswered(true));
    };

    window.onReset = () => {
      dispatch(setAnswered(false));
    };
  };

  return (
    <video id="video_1" className="video-js vjs-theme-city" playsInline />
  );
}